import React, { Component } from "react";
import { MAX_PAGE_WIDTH, EXPERIENCE, APPS } from "../Constants";
import DKLabel from "./common/DKLabel";
import About from "./About";
import JobDetails from "./JobDetails";
import DKButton from "./common/DKButton";
import { DKIcons } from "../Constants/DKIcons";
import AppDetails from "./AppDetails";
import ic_piyush_1 from "../assets/ic_piyush_1.png";
import DKIcon from "./common/DKIcon";

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.sectionStyle = "bg-gray1 p-l border-box mt-xxl border-radius-s";
  }
  render() {
    return (
      <div
        style={{
          maxWidth: MAX_PAGE_WIDTH,
          // backgroundColor: "rgb(252, 252, 252)",
        }}
        className="bg-white p-xxl-responsive parent-width border-box shadow-s"
      >
        <About />
        {this.getExperineceSection()}
        {this.getWorkSection()}
        {this.getAwardSection()}
        {this.getEducationSection()}
        {this.getContactSection()}
        {this.getFooter()}
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getExperineceSection() {
    return (
      <div className={this.sectionStyle}>
        <DKLabel text=" 🙋‍♂️ Work Experience" className="fw-m fs-l  " />
        <div className="row mt-r flex-wrap">
          <JobDetails data={EXPERIENCE.DESKERA} />
          <JobDetails data={EXPERIENCE.ANGEL} />
          <JobDetails data={EXPERIENCE.I2E} />
          <JobDetails data={EXPERIENCE.TATA} />
          <JobDetails data={EXPERIENCE.GAMESHASTRA} />
          <JobDetails data={EXPERIENCE.HUNGAMA} />
          <JobDetails data={EXPERIENCE.RELIANCE} />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getWorkSection() {
    return (
      <div className={this.sectionStyle}>
        <DKLabel text=" 👨‍💻 My Work" className="fw-m fs-l  " />
        <div className="row mt-r flex-wrap align-items-start">
          <AppDetails data={APPS.DESKERA} />
          <AppDetails data={APPS.DASHBOARD} />
          <AppDetails data={APPS.DESKERA_APP} />
          <AppDetails data={APPS.TASKIFY_APP} />
          <AppDetails data={APPS.MAPPY_APP} />
          <AppDetails data={APPS.WEBSITE_BUILDER_APP} />
          <AppDetails data={APPS.INVOICE_APP} />
          <AppDetails data={APPS.REPORT_APP} />
          <AppDetails data={APPS.SHOP_APP} />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getAwardSection() {
    return (
      <div className={this.sectionStyle}>
        <DKLabel text=" 🏆 Awards & recongnition" className="fw-m fs-l  " />
        <div className="mt-r pl-xl">
          <DKLabel text="• Employee of the year 🥇" className="" />
          <DKLabel text="• Best Tabby app award 🏅" className="mt-s" />
          <DKLabel text="• Webby award honoree 2020 🎖" className="mt-s" />
          <DKLabel text="• Product of the day 🥈" className="mt-s" />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getEducationSection() {
    return (
      <div className={this.sectionStyle}>
        <DKLabel text=" 🖋 Education" className="fw-m fs-l  " />
        <div className="mt-r pl-xl">
          <DKLabel
            text="VYWS College of engineering, Badnera"
            className="fw-b mt-l"
          />
          <DKLabel
            text="Bachelor's degree in Computer Science (A)"
            className="mt-xs"
          />
          <DKLabel text="2002-2006" className="text-gray mt-xs" />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getContactSection() {
    return (
      <div className={this.sectionStyle}>
        <DKLabel text=" 👦🏻 Contact" className="fw-m fs-l  " />
        <div className="column mt-m flex-wrap align-items-start">
          <DKButton
            title="pkandrikar@gmail.com"
            icon={DKIcons.ic_email}
            className="ml-m"
            m
          />
          <DKButton
            title="+65 9350 9479 , +91 80073 23625"
            icon={DKIcons.ic_phone}
            className="mt-r ml-m"
          />
          <DKButton
            title="Singapore"
            icon={DKIcons.ic_location}
            className="mt-r ml-m"
          />
        </div>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="column parent-width align-items-center mt-xl mb-xl">
        <DKIcon src={ic_piyush_1} className="ic-xl border-m circle mt-l" />

        <DKLabel text="Piyush Kandrikar" className="fw-m fs-l mt-s" />
        <DKLabel text="Programmed & Designed by 👆" className=" text-gray" />
      </div>
    );
  }
}

export default LandingPage;
